import { map, filter } from 'lodash'

export const error = state => state.error
export const isLoading = state => state.isLoading
export const updated = state => state.updated
export const retrieved = state => state.retrieved
export const violations = state => state.violations

export const languages = state => state.languages
export const languagesLoading = state => state.languagesLoading

export const translationLoading = state => state.translationLoading
export const translation = state => state.translation
export const translationError = state => state.translationError

export const brands = state => state.brands
export const brandsLoading = state => state.brandsLoading

export const selectedBrandTab = state => state.selectedBrandTab

export const isLoadingGameFileVersion = state => state.isLoadingGameFileVersion
export const gameFileVersionError = state => state.gameFileVersionError
export const gameFileVersionViolations = state => state.gameFileVersionViolations
export const gameFileVersions = state => state.gameFileVersions
export const gameFileVersionsView = state => state.gameFileVersionsView
export const gameFileVersionsTotalItems = state => state.gameFileVersionsTotalItems

export const publishedGameFile = state => state.publishedGameFile
export const publishGameFileError = state => state.publishGameFileError
export const publishGameFileLoading = state => state.publishGameFileLoading

export const getRetrievedData = state => {
  if (state.retrieved) {
    const data = { id: state.retrieved.id, name: state.retrieved.name, description: state.retrieved.description, active: state.retrieved.active }
    data['@id'] = state.retrieved['@id']
    return data
  } else {
    return { id: '', name: '', description: '', active: false }
  }
}

export const getRetrievedGameFileVersions = state => {
  let count = 0

  const brandGameFileVersions = filter(state.gameFileVersions, (version) => {
    if (state.retrieved) {
      if (state.selectedBrandTab) {
        return version.game === state.retrieved['@id'] && version.brand === state.selectedBrandTab['@id']
      }
      return version.game === state.retrieved['@id']
    }
  })

  return map(brandGameFileVersions, (version) => {
    count++
    return { data: version, columns: createGameFileColumn(version, count) }
  })
}

function createGameFileColumn (version, count) {
  return [
    { field: 'version', value: count, type: 'number' },
    { field: 'publish-link', value: version.published ? 'Active' : 'Publish', type: version.published ? 'string' : 'link' },
    { field: 'play-link', value: version.path ? 'Play' : 'N/A', type: version.path ? 'link' : 'string' }
  ]
}
